<template>
    <v-container fluid>   
      <LeftMenu/>     
        <v-layout row wrap>   
          <v-flex xs1></v-flex>
          <v-flex xs10>
            <v-data-table
              :headers="headers"
              :items="bankAccountsWithTransfers"
              :items-per-page="50"
              item-key="id"
              sort-by="bankAccount"
              class="elevation-1"
              show-expand
              :custom-filter="filterOnlyCapsText"
              >
              <template v-slot:top>
                <v-toolbar flat color="white">
                  <v-toolbar-title>Bank Accounts</v-toolbar-title>
                  <v-divider
                    class="mx-4"
                    inset
                    vertical
                  ></v-divider>
                  <v-flex xs2 class="pr-3">
                    <DatePicker picker-label="" :date-value="startDate" @dateSelected="startDate=$event" />
                  </v-flex>
                  <v-flex xs2 class="pr-3"> 
                    <DatePicker picker-label="" :date-value="endDate" @dateSelected="endDate=$event" />                  
                  </v-flex> 
                  <v-flex xs2 sm6 md2>   
                      <v-combobox
                        :items="bankAccounts"
                        label="Select Account"
                        v-model="selectedAccount"
                        item-text="accountName"
                        single-line
                        return-object
                      ></v-combobox>    
                  </v-flex> 
                  <v-flex xs1 md1> 
                    <v-btn color="primary" dark class="mb-2" @click="showTransactions">Transactions</v-btn>
                  </v-flex>
                  <v-spacer></v-spacer>
                  <v-dialog v-model="dialog" max-width="900px">
                    <template v-slot:activator="{ on }">
                      <v-btn color="primary" dark class="mb-2" v-on="on">New Bank Account</v-btn>
                    </template>
                    <v-card>
                      <v-card-title>
                        <span class="headline">{{ formTitle }}</span>
                      </v-card-title>

                      <v-card-text>
                        <v-container grid-list-md>
                          <v-layout wrap>
                            <v-flex xs12 sm6 md6>
                              <v-text-field v-model="editedItem.accountName" label="Account Name"></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 md6>
                              <v-text-field v-model="editedItem.iban" label="IBAN"></v-text-field>
                            </v-flex>   
                            <v-flex xs12 sm6 md6>
                              <v-text-field v-model="editedItem.accountNumber" label="Account Number"></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 md6>   
                              <v-combobox
                                :items="currencyListWithText"
                                label="Select Currency"
                                v-model="editedItem.currency"
                                item-text="text"
                                single-line
                                return-object
                              ></v-combobox>                           
                            </v-flex>      
                            <v-flex xs12 sm6 md6> 
                              <v-currency-field 
                                :key="editedItem.id"
                                v-model="editedItem.startBalance" 
                                :label="bankStartConfig.displayText"
                                ></v-currency-field>
                            </v-flex>                                                                                                                                                                
                          </v-layout>
                        </v-container>
                      </v-card-text>

                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="error" dark class="mb-2" @click="close">Cancel</v-btn>
                        <v-btn color="success" dark class="mb-2" @click="save">Save</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>

                  <v-dialog v-model="transferDialog" max-width="900px">                    
                    <v-card>
                      <v-card-title>
                        <span class="headline">Transfer Between Accounts</span>
                      </v-card-title>

                      <v-card-text>
                        <v-container grid-list-md>
                          <v-layout wrap>                            
                            <v-flex xs12 sm6 md6>
                              <v-text-field 
                                v-model="editedTransferItem.fromAccount.accountName" 
                                label="From Account Name"
                                disabled></v-text-field>
                            </v-flex>                                                          
                            <v-flex xs12 sm6 md6>   
                              <v-combobox
                                :items="filteredBankAccounts"
                                label="Select Target Account"
                                v-model="editedTransferItem.toAccount"
                                item-text="accountName"
                                single-line
                                return-object
                                v-on:change="here"
                              ></v-combobox>                         
                            </v-flex>      
                            <v-flex xs12 sm6 md3>                               
                              <DatePicker picker-label="Date" :date-value="editedTransferItem.transferDate" @dateSelected="editedTransferItem.transferDate=$event" />
                            </v-flex> 
                            <v-flex xs12 sm6 md5> 
                              <v-currency-field 
                                :key="editedTransferItem.id"
                                v-model="editedTransferItem.fromAmount" 
                                label="From Account Amount"
                                ></v-currency-field>
                            </v-flex>  
                            <v-flex xs12 sm6 md4> 
                              <v-currency-field 
                                :key="editedTransferItem.id"
                                v-if="editedTransferItem.toAccount && editedTransferItem.fromAccount.currency.code !== editedTransferItem.toAccount.currency.code"
                                v-model="editedTransferItem.toAmount" 
                                label="Target Account Amount"
                                ></v-currency-field>
                            </v-flex>                                                                                                                                                                                           
                          </v-layout>
                        </v-container>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="error" dark class="mb-2" @click="closeTransferDialog">Cancel</v-btn>
                        <v-btn color="success" dark class="mb-2" @click="saveTransfer">Save</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>

                  <v-dialog v-model="transactionsDialog" max-width="1200px">                    
                    <v-card>
                      <v-card-title>
                        <Xlsx filename="bank_transactions" :items="xlsxItems"  :headers="xlsxHeaders" />   
                        <span class="headline">{{ selectedAccount.accountName }}  Transactions </span> 
                      </v-card-title>

                      <v-card-text>
                        <v-container grid-list-md>
                          <v-layout wrap>                            
                            <v-flex xs12 sm6 md12>
                              
                               <v-data-table
                                :headers="transactionsHeaders"
                                :items="transactionsListFormatted"
                                :items-per-page="50"
                                item-key="id"
                                sort-by="transfersDate"
                                :sort-desc=true
                                class="elevation-1"
                                >                      
                              </v-data-table>

                            </v-flex>                                                                                                                                                                                                                                  
                          </v-layout>
                        </v-container>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="error" dark class="mb-2" @click="closeTransactionsDialog">Close</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>

                </v-toolbar>
                <v-text-field v-model="search" label="Search " class="mx-4"></v-text-field>
              </template> 
              <template v-slot:expanded-item="{ headers, item: masterItem }">
                <td :colspan="headers.length" >                  
                  <v-layout row wrap>   
                    <v-flex xs12/>
                    <v-flex xs3>
                      Transfers of {{ masterItem.accountName }}                    
                    </v-flex>
                    <v-flex xs9>                       
                    </v-flex>
                    <v-flex xs12>




                      <v-data-table
                      :headers="transfersHeaders"
                      :items="masterItem.transfers"
                      :items-per-page="5"
                      item-key="id"
                      sort-by="transfersDate"
                      :sort-desc=true
                      class="elevation-1"
                      >                      
                      <template v-slot:body.append>                    
                      </template>             
                      <template v-slot:item.transferAction="{ item }">              
                        <v-icon                  
                          @click="editTransferItem(item,masterItem)">
                          mdi-table-edit
                        </v-icon>
                        <v-icon                  
                          @click="deleteTransferItem(item,masterItem)"
                        >
                          mdi-delete
                        </v-icon>
                      </template>
                    </v-data-table>



                    </v-flex>
                  </v-layout>
                </td>                
              </template>
              <template v-slot:body.append>                    
              </template>     
              <template v-slot:item.transfer="{ item }">              
                <v-icon                  
                  @click="transferFromAccount(item)">
                  mdi-transfer
                </v-icon>               
              </template>        
              <template v-slot:item.action="{ item }">              
                <v-icon                  
                  @click="editItem(item)">
                  mdi-table-edit
                </v-icon>
                <v-icon                  
                  @click="deleteItem(item)"
                >
                  mdi-delete
                </v-icon>
              </template>
            </v-data-table>
          </v-flex>
          <v-flex xs1></v-flex>
        </v-layout>
    </v-container>
</template>
<script>
import LeftMenu from '../../components/LeftMenu';
import DatePicker from '../../components/DatePicker';
import formatPrice from '../../helpers/formatter';
import Xlsx from '../../components/Xlsx';
const API_URL = 'definitions/bankAccounts';
const ACCOUNTS_BALANCE_API_URL = 'definitions/bankAccountsWithBalance';
const CURRENCIES_API_URL = 'definitions/currencies';
const TRANSFERS_API_URL = 'transfers';
const CONFIG_API_URL = 'definitions/config/BANK_ACCOUNTS_START_DATE';
export default {
    components:{
      LeftMenu,
      DatePicker,
      Xlsx
    },
    data () {
    return {
      transferDialog: false,
      dialog: false,
      transactionsDialog: false,
      search: '',
      startDate: '',
      endDate: '',
      selectedAccount: '',
      bankStartConfig: '',      
      currencyList:[],
      transactionsList:[],
      filteredBankAccounts: [],
      bankAccounts: [],
      editedTransferItem: {
        fromAccount: '',
        toAccount: '',
        amount: '', 
      },
      editedIndex: -1,
      editedTransferIndex: -1,
      expandedItem : {
        transfers : []
      },
      editedItem: {
        model: '',
          category: '',
          explanation: '', 
      },
      defaultItem: {
        model: '',
          category: '',
          explanation: '', 
      },
      defaultTransferItem: {
        fromAccount: ''
      },
      xlsxHeaders:{ 
        transactionDate: 'Date',          
        type : 'Type',  
        amount : 'Amount',                       
        startBalance: 'Start Balance' ,
        currentBalance: 'End Balance' ,
        explanation : 'Explanation' 
      },   
      
    }
  },
  computed: {
    headers () {
      return [
        { text: 'Transfer',  value: 'transfer'  },          
        { text: 'Account Name', align: 'left', sortable: true, value: 'accountName'},
        { text: 'IBAN',  value: 'iban'  },          
        { text: 'Account Number',  value: 'accountNumber'  },     
        { text: 'Balance',  value: 'currentBalanceFormatted', align: 'right',  },     
        { text: 'Currency',  value: 'currency.text'  },          
        { text: 'Actions', value: 'action', sortable: false },
      ]
    },
    transfersHeaders () {
      return [
        { text: 'Transfer Date',  value: 'transferDate'  },          
        { text: 'From Account', align: 'left', sortable: true, value: 'fromAccount.accountName'},
        { text: 'From Amount',  value: 'fromAmount'  },    
        { text: 'To Account',  value: 'toAccount.accountName'  },                   
        { text: 'To Amount',  value: 'toAmount'  },          
        { text: 'Transfer Actions', value: 'transferAction', sortable: false },
      ]
    },
    transactionsHeaders () {
      return [
        { text: 'Date',  value: 'transactionDate'  },          
        { text: 'Type',  value: 'type'},
        { text: 'Amount',  value: 'amountFormatted'  },                     
        { text: 'Start Balance',  value: 'startBalanceFormatted'  },
        { text: 'End Balance',  value: 'currentBalanceFormatted'  },
        { text: 'Explanation',  value: 'explanation'  }
      ]
    }, 
    formTitle () {
      return this.editedIndex === -1 ? 'New Bank Account' : 'Edit Bank Account'
    },
    currencyListWithText(){
      return this.currencyList.map((item) => {
        return {
          id: item.id,
          code: item.code,
          text: item.code+' - '+item.text          
        };
      })
    },
    bankAccountsWithTransfers(){
      return this.bankAccounts.map((item) => {
        item.transfers = this.getTransfersByAccount(item);
        item.currentBalanceFormatted = formatPrice(item.currentBalance)
        return item;  
      })
    },
    transactionsListFormatted(){
      return this.transactionsList.map((item) => {
        item.startBalanceFormatted = formatPrice(item.startBalance);
        item.currentBalanceFormatted = formatPrice(item.currentBalance);
        item.amountFormatted = formatPrice(item.amount);
        return item;  
      })
    },
    xlsxItems(){
      return this.transactionsList.map((item) => {
        return {
          transactionDate: item.transactionDate,
          type : item.type,
          amount : formatPrice(item.amount),
          startBalance  : formatPrice(item.startBalance),
          currentBalance  : formatPrice(item.currentBalance),
          explanation : item.explanation
        }
      });
    },
  },
  created() {    
    this.getCurrencies();
    this.getBankAccounts();
    this.getSystemStartConfig();
  },
  watch: {
    dialog (val) {
      val || this.close()
    },
    transferDialog(val){
      val || this.closeTransferDialog()
    },
    transactionsDialog(val){
      val || this.closeTransactionsDialog()
    },
  },
  methods: {
    here(){
      //editedTransferItem.toAccount && editedTransferItem.fromAccount.currency !== editedTransferItem.toAccount.currency.id
      console.log(this.editedTransferItem.fromAccount);
      console.log(this.editedTransferItem.toAccount);
    },
    showTransactions(){
      if(!this.startDate){
        alert('Select Start Date');
        return;
      }
      if(!this.endDate){
        alert('Select End Date');
        return;
      }
      if(!this.selectedAccount){
        alert('Select Account');
        return;
      }
      this.getAccountTransactions();
    },
    transferFromAccount(item){ 
      this.editedTransferItem.fromAccount = Object.assign({}, item); 
      this.filteredBankAccounts = this.bankAccounts.filter((p) => {
        	return (p.iban !=item.iban )
        });

      this.transferDialog = true
    },  
    editTransferItem(item, masterItem){  
      this.editedTransferIndex = masterItem.transfers.indexOf(item)
      this.editedTransferItem = Object.assign({}, item)
      this.filteredBankAccounts = this.bankAccounts.filter((p) => {
        	return (p.iban !=masterItem.iban )
        });

      this.transferDialog = true
    },   
     
    editItem (item) {
      this.editedIndex = this.bankAccounts.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },
     
    deleteItem (item) {
      const index = this.bankAccounts.indexOf(item)
      if(confirm('Are you sure you want to delete this item?')){
        this.bankAccounts.splice(index, 1);
        this.deleteBankAccount(item);
      } 
    },
    deleteTransferItem (item, masterItem) {
      const index = masterItem.transfers.indexOf(item)
      if(confirm('Are you sure you want to delete this item?')){
        masterItem.transfers.splice(index, 1);
        this.deleteTransfer(item);
      } 
    },

    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    closeTransferDialog () {
      this.transferDialog = false
      setTimeout(() => {
        this.editedTransferItem = Object.assign({}, this.defaultTransferItem)
        this.editedTransferIndex = -1
      }, 300)
    },    
    closeTransactionsDialog(){
      this.transactionsDialog = false;
    },
    save () {
      if (this.editedIndex > -1) {        
        this.updateBankAccount(this.editedItem);
      } else {
        this.addBankAccount(this.editedItem);         
      }      
    },
    saveTransfer(){    
      if(this.editedTransferItem.toAccount && this.editedTransferItem.fromAccount && 
           this.editedTransferItem.fromAccount.currency &&  this.editedTransferItem.toAccount.currency 
           && this.editedTransferItem.fromAccount.currency.code === this.editedTransferItem.toAccount.currency.code){
        this.editedTransferItem.toAmount = this.editedTransferItem.fromAmount;
      }
      if (this.editedTransferIndex > -1) {        
        this.updateTransfer(this.editedTransferItem);
      } else {
        this.addTransfer(this.editedTransferItem);         
      } 
    },
    addTransfer(transferItem){
      this.$axios.post(this.$apiurl + TRANSFERS_API_URL, {
        toAmount: transferItem.toAmount,
        fromAmount: transferItem.fromAmount,
        transferDate: transferItem.transferDate,
        fromAccountId: transferItem.fromAccount ? transferItem.fromAccount.id : null,
        toAccountId: transferItem.toAccount ? transferItem.toAccount.id : null
      })
      .then(response => {        
        if (response.status === 201) {
          this.getBankAccounts();
          this.closeTransferDialog();
        } 
      }) 
      .catch(error => {
        console.log(error);
      }); 
    },
    updateTransfer(transferItem){
      let that = this;
      this.$axios.put(this.$apiurl + TRANSFERS_API_URL, {
        id : transferItem.id,
        toAmount: transferItem.toAmount,
        fromAmount: transferItem.fromAmount,
        transferDate: transferItem.transferDate,
        fromAccountId: transferItem.fromAccount ? transferItem.fromAccount.id : null,
        toAccountId: transferItem.toAccount ? transferItem.toAccount.id : null
      })
      .then(response => {
        if (response.status === 200) {
          this.getBankAccounts();
          this.closeTransferDialog();
        }         
      }) 
      .catch(error => {
        console.log(error);
      }); 
    },
    addBankAccount(item){
      this.$axios.post(this.$apiurl + API_URL, {
        accountNumber: item.accountNumber,
        iban: item.iban,
        accountName: item.accountName,
        currency: item.currency.id,
        startBalance : item.startBalance
      })
      .then(response => {        
        if (response.status === 201) {
          this.editedTransferItem.fromAccount.transfers.push(item);
          this.close();
        } 
      }) 
      .catch(error => {
        console.log(error);
      }); 
    },
    updateBankAccount(item){
      let that = this;
      this.$axios.put(this.$apiurl + API_URL, {
        id: item.id,
        accountNumber: item.accountNumber,
        iban: item.iban,
        accountName: item.accountName,
        currency: item.currency.id,
        startBalance : item.startBalance
      })
      .then(response => {
        if (response.status === 200) {
          Object.assign(that.bankAccounts[that.editedIndex], item);
          this.close();
        }         
      }) 
      .catch(error => {
        console.log(error);
      }); 
    },
    deleteBankAccount(item){
      this.$axios.delete(this.$apiurl + API_URL+'/'+item.id)
      .then(response => {
      }) 
      .catch(error => {
        console.log(error);
      }); 
    },
    deleteTransfer(item){
      this.$axios.delete(this.$apiurl + 'transfers/'+item.id)
      .then(response => {
        if (response.status === 200) {
          this.getBankAccounts();
        } 
      }) 
      .catch(error => {
        console.log(error);
      }); 
    },
    getBankAccounts(){     
        this.$axios.get(this.$apiurl + ACCOUNTS_BALANCE_API_URL)
            .then(response => {
                this.bankAccounts = response.data
            }) 
            .catch(error => {
                console.log(error);
            });                         
    },
    getAccountTransactions(){
      if(this.selectedAccount){
       this.$axios.get(this.$apiurl +"definitions/bankAccountTransactions/"+ this.selectedAccount.id,{ 
              params: {
                startDate: this.startDate,
                endDate: this.endDate
              }                                               
           })
            .then(response => {
                this.transactionsList = response.data;
                this.transactionsDialog = true;
            }) 
            .catch(error => {
                console.log(error);
            });    
      }
    },
    getTransfersByAccount(account){     
        this.$axios.get(this.$apiurl + TRANSFERS_API_URL+"/account/"+account.id)
            .then(response => {
                account.transfers = response.data;
            }) 
            .catch(error => {
                console.log(error);
            });                         
    },
    getSystemStartConfig(){
      this.$axios.get(this.$apiurl + CONFIG_API_URL)
        .then(response => {
            this.bankStartConfig = response.data;
            this.bankStartConfig.displayText = "Balance As Of "+this.bankStartConfig.configValue;
        }) 
        .catch(error => {
            console.log(error);
        });  
    },
    getCurrencies(){     
      this.$axios.get(this.$apiurl + CURRENCIES_API_URL)
          .then(response => {
              this.currencyList = response.data
          }) 
          .catch(error => {
              console.log(error);
          });                         
    },   
    filterOnlyCapsText (value, search) {
      return value != null &&
        search != null &&
        typeof value === 'string' &&
        value.toString().toLocaleUpperCase().indexOf(search.toLocaleUpperCase()) !== -1
    },
  },
}
</script>
